'use client';

import {
  createContext,
  useContext,
  useReducer,
  ReactNode,
  Dispatch,
} from 'react';

interface ClientState {
  isCreateClientPopupOpen: boolean;
  isEditClientPopupOpen: boolean;
  clientId: string | null;
}

type ClientAction =
  | { type: 'OPEN_CREATE_CLIENT_POPUP' }
  | { type: 'CLOSE_CREATE_CLIENT_POPUP' }
  | { type: 'OPEN_EDIT_CLIENT_POPUP'; payload: { clientId: string } }
  | { type: 'CLOSE_EDIT_CLIENT_POPUP' };

const initialState: ClientState = {
  isCreateClientPopupOpen: false,
  isEditClientPopupOpen: false,
  clientId: null,
};

const ClientContext = createContext<{
  state: ClientState;
  dispatch: Dispatch<ClientAction>;
} | null>(null);

function clientReducer(state: ClientState, action: ClientAction): ClientState {
  switch (action.type) {
    case 'OPEN_CREATE_CLIENT_POPUP':
      return { ...state, isCreateClientPopupOpen: true };
    case 'CLOSE_CREATE_CLIENT_POPUP':
      return { ...state, isCreateClientPopupOpen: false };
    case 'OPEN_EDIT_CLIENT_POPUP':
      return {
        ...state,
        isEditClientPopupOpen: true,
        clientId: action.payload.clientId,
      };
    case 'CLOSE_EDIT_CLIENT_POPUP':
      return { ...state, isEditClientPopupOpen: false, clientId: null };
    default:
      return state;
  }
}

export const ClientProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(clientReducer, initialState);
  return (
    <ClientContext.Provider value={{ state, dispatch }}>
      {children}
    </ClientContext.Provider>
  );
};

export const useClientContext = () => {
  const context = useContext(ClientContext);
  if (!context)
    throw new Error('useClientContext must be used within ClientProvider');
  return context;
};

// "use client";

// import {
//   createContext,
//   useContext,
//   useReducer,
//   ReactNode,
//   Dispatch,
// } from "react";

// interface ModalState {
//   isCreatePopupOpen: boolean;
//   isEditPopupOpen: boolean;
//   selectedId: string | null;
// }

// type ModalAction =
//   | { type: "OPEN_CREATE_POPUP" }
//   | { type: "CLOSE_CREATE_POPUP" }
//   | { type: "OPEN_EDIT_POPUP"; payload: { id: string } }
//   | { type: "CLOSE_EDIT_POPUP" };

// const initialState: ModalState = {
//   isCreatePopupOpen: false,
//   isEditPopupOpen: false,
//   selectedId: null,
// };

// function modalReducer(state: ModalState, action: ModalAction): ModalState {
//   switch (action.type) {
//     case "OPEN_CREATE_POPUP":
//       return { ...state, isCreatePopupOpen: true };
//     case "CLOSE_CREATE_POPUP":
//       return { ...state, isCreatePopupOpen: false };
//     case "OPEN_EDIT_POPUP":
//       return {
//         ...state,
//         isEditPopupOpen: true,
//         selectedId: action.payload.id,
//       };
//     case "CLOSE_EDIT_POPUP":
//       return { ...state, isEditPopupOpen: false, selectedId: null };
//     default:
//       return state;
//   }
// }

// // Generic factory function
// export function createModalContext(entityName: string) {
//   const Context = createContext<{
//     state: ModalState;
//     dispatch: Dispatch<ModalAction>;
//   } | null>(null);

//   const Provider = ({ children }: { children: ReactNode }) => {
//     const [state, dispatch] = useReducer(modalReducer, initialState);
//     return (
//       <Context.Provider value={{ state, dispatch }}>
//         {children}
//       </Context.Provider>
//     );
//   };

//   const useHook = () => {
//     const context = useContext(Context);
//     if (!context) {
//       throw new Error(
//         `use${entityName}Context must be used within ${entityName}Provider`
//       );
//     }
//     return context;
//   };

//   return { Provider, useHook };
// }

// // Create specific contexts
// export const { Provider: ClientProvider, useHook: useClientContext } =
//   createModalContext("Client");

// export const { Provider: InvoiceProvider, useHook: useInvoiceContext } =
//   createModalContext("Invoice");

// export const { Provider: ProductProvider, useHook: useProductContext } =
//   createModalContext("Product");

// // Helper hooks for cleaner usage
// export const useClientModal = () => {
//   const { state, dispatch } = useClientContext();
//   return {
//     isCreateOpen: state.isCreatePopupOpen,
//     isEditOpen: state.isEditPopupOpen,
//     selectedId: state.selectedId,
//     openCreate: () => dispatch({ type: "OPEN_CREATE_POPUP" }),
//     closeCreate: () => dispatch({ type: "CLOSE_CREATE_POPUP" }),
//     openEdit: (id: string) =>
//       dispatch({ type: "OPEN_EDIT_POPUP", payload: { id } }),
//     closeEdit: () => dispatch({ type: "CLOSE_EDIT_POPUP" }),
//   };
// };

// export const useInvoiceModal = () => {
//   const { state, dispatch } = useInvoiceContext();
//   return {
//     isCreateOpen: state.isCreatePopupOpen,
//     isEditOpen: state.isEditPopupOpen,
//     selectedId: state.selectedId,
//     openCreate: () => dispatch({ type: "OPEN_CREATE_POPUP" }),
//     closeCreate: () => dispatch({ type: "CLOSE_CREATE_POPUP" }),
//     openEdit: (id: string) =>
//       dispatch({ type: "OPEN_EDIT_POPUP", payload: { id } }),
//     closeEdit: () => dispatch({ type: "CLOSE_EDIT_POPUP" }),
//   };
// };

// export const useProductModal = () => {
//   const { state, dispatch } = useProductContext();
//   return {
//     isCreateOpen: state.isCreatePopupOpen,
//     isEditOpen: state.isEditPopupOpen,
//     selectedId: state.selectedId,
//     openCreate: () => dispatch({ type: "OPEN_CREATE_POPUP" }),
//     closeCreate: () => dispatch({ type: "CLOSE_CREATE_POPUP" }),
//     openEdit: (id: string) =>
//       dispatch({ type: "OPEN_EDIT_POPUP", payload: { id } }),
//     closeEdit: () => dispatch({ type: "CLOSE_EDIT_POPUP" }),
//   };
// };
